import React, { Fragment } from 'react';
import { Button, Loading } from '@/components';
import { toCurrency } from '@/helpers/masks/toCurrency';
import { DataList } from '@/components/DataList';
import EventReportProduct from '@/model/EventReportProduct';
import { States } from '@/helpers/common/states';
import { ReactComponent as TriagingFaceDown } from '@/assets/images/svg/TriagingFaceDown.svg';
import { ReactComponent as CheckStep } from '@/assets/images/svg/CheckStep.svg';

export interface SaleSubPdvContentProps {
  generatePDF: () => void;
  state: States;
  product: EventReportProduct;
  steps: any[];
  handleClickStep: (step: number) => void;
}

export const SaleProdutContent: React.FC<SaleSubPdvContentProps> = ({
  state,
  product,
  steps,
  handleClickStep,
  generatePDF,
}) => (
  <Fragment>
    <Loading isVisible={state === States.loading} />
    <div className="d-flex justify-content-between">
      <h5>Vendas por Produtos</h5>
      <Button theme="outlineDark" onClick={() => generatePDF()} title="Exportar relatório" />
    </div>
    <div>
      <h6 className="mb-2 mt-4" style={{ paddingLeft: '1.5rem' }}>
        Vendas totais dos produtos no evento
      </h6>
      <hr />
    </div>
    <div>
      <div
        className="customTableScroll p-4"
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr',
          gridColumnGap: '40px',
          overflow: 'auto',
          alignItems: 'end',
        }}
      >
        <DataList
          data={
            product && product.payment
              ? [
                  {
                    title: 'Vendidos:',
                    content: product.amountSale ? `${product.amountSale}` : '-----',
                  },
                  {
                    title: `Crédito (${
                      product && product.payment
                        ? (
                            ((product.payment.credit + product.payment.installmentSaleTotal) *
                              100) /
                            product.saleValue
                          ).toFixed(2)
                        : 0
                    } %)`,
                    content: product.payment
                      ? `${toCurrency(
                          product.payment.credit + product.payment.installmentSaleTotal,
                        )}`
                      : '-----',
                  },
                  {
                    title: `Débito (${
                      product && product.payment
                        ? ((product.payment.debit * 100) / product.saleValue).toFixed(2)
                        : 0
                    } %)`,
                    content: product.payment ? `${toCurrency(product.payment.debit)}` : '-----',
                  },
                  {
                    title: `Pix (${
                      product && product.payment
                        ? ((product.payment.pix * 100) / product.saleValue).toFixed(2)
                        : 0
                    } %)`,
                    content: product.payment ? `${toCurrency(product.payment.pix)}` : '-----',
                  },
                  {
                    title: `Dinheiro (${
                      product && product.payment
                        ? ((product.payment.money * 100) / product.saleValue).toFixed(2)
                        : 0
                    } %)`,
                    content: product.payment ? `${toCurrency(product.payment.money)}` : '-----',
                  },
                  {
                    title: 'Faturamento:',
                    content: product.saleValue
                      ? `${toCurrency(product.saleValue + product.fee)}`
                      : '-----',
                  },
                ]
              : []
          }
        />
      </div>
    </div>
    <div className="container-fluid mainContainer">
      <div className="progress-step">
        {steps.map((step, index) => {
          const { status } = step;
          return (
            <React.Fragment key={index}>
              <div
                className={`progress-step__item cursor__${status}`}
                onClick={() => handleClickStep(index)}
              >
                <div className="progress-step__item__status">
                  <div className={`progress-step__item__status__${status}`}>
                    {status === 'current' && (
                      <>
                        <TriagingFaceDown />
                      </>
                    )}
                    {status === 'done' && (
                      <span>
                        <CheckStep />
                      </span>
                    )}
                    {status !== 'done' && <span>{index + 1}</span>}
                  </div>
                </div>
                <div className="progress-step__item__title">
                  <span className={`progress-step__item__title__${status}`}>{step.title}</span>
                </div>
              </div>
              {index < steps.length - 1 && (
                <div className="progress-step__line">
                  <div className={`progress-step__line__${status}`} />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
    {steps.map((step, index) => {
      if (step.status === 'current') {
        return <React.Fragment key={index}>{step.component}</React.Fragment>;
      }
      return null;
    })}
  </Fragment>
);
